<div
  class="event-item"
  role="button"
  tabindex="0"
  aria-label="Ritdetails openen"
  [ngClass]="cssClasses()"
  [style.border-left-color]="getVehicleColor()"
  (click)="onItemClick()"
  (keydown.enter)="onItemClick()"
  (keydown.space)="$event.preventDefault(); onItemClick()"
>
  <div class="event-header">
    <div class="event-title">
      <h2 class="event-main-title">
        @if (ride(); as currentRide) {
          @if (!currentRide.automaticallyPlanned && !currentRide.vehicleId) {
            <!-- Reuse the calendar's Material Icons font markup for consistent rendering in both views. -->
            <span class="ride-warning-icon" aria-hidden="true">warning</span>
          }
        }
        {{ getTitle() }}
      </h2>
      @if (driverName()) {
        <p class="driver-name"><b>Chauffeur:</b> {{ driverName() }}</p>
      }
      @if (coDriverName() && dataStore.generalSettings.coDriverEnabled) {
        <p class="driver-name"><b>Bijrijder:</b> {{ coDriverName() }}</p>
      }
    </div>
  </div>
  @if (ride()) {
    <div class="event-details">
      <h3 class="event-title">Passagiers</h3>
      <div class="event-users">
        @for (user of rideUsers(); track user.id) {
          <div class="user-info">
            <div class="user-contact">
              <p class="value">{{ user.title }}</p>
              @if (getPhoneNumber(user); as phoneNumber) {
                <a href="tel:{{ phoneNumber }}" class="phone" (click)="$event.stopPropagation()">
                  {{ phoneNumber }}
                </a>
              }
            </div>
            <div class="user-time">
              <p class="label">Tijd</p>
              <p class="value">{{ formatTime(user.userPickupTime) }} - {{ formatTime(user.userDropoffTime) }}</p>
            </div>
            @if (getLocation(user); as location) {
              <div class="user-location">
                <p class="label">Locatie</p>
                <p class="value">{{ location }}</p>
              </div>
            }
            @if (user.commentsForDriver && type() === 'driver') {
              <div class="user-comment">
                <p class="comments-label">Opmerking (Voor chauffeur)</p>
                <p class="comments-text">{{ user.commentsForDriver }}</p>
              </div>
            }
          </div>
        }
      </div>
      @if (ride().locationsOrder?.length > 0) {
        <button mat-flat-button class="maps-button primary-color" (click)="onMapsClick($event)">Open maps</button>
      }
    </div>

    @if (ride().comments) {
      <div class="event-comments">
        <p class="comments-label">Opmerking (Rit):</p>
        <p class="comments-text">{{ ride().comments }}</p>
      </div>
    }

    @if (ride().exception && type() === 'planning') {
      <div class="event-exception">
        <p class="exception-label">Uitzondering:</p>
        <p class="exception-text">{{ ride().exception.title }}</p>
      </div>
    }
  }
</div>
